angular.module('impactx.approval').directive('ixApprovalBasketIcon', function() {
    return {
        scope: {
            hideIcon: '=',
            size: "="
        },
        restrict: 'E',
        templateUrl: 'shared/approval/templates/approval-basket-icon.tmpl.html',
        link: function(scope) {
            scope.$watch('size', function(newValue) {
                scope.sizeClass = 'basket-approval-icon-divider-size-1';
                if(newValue) {
                    scope.sizeClass = 'basket-approval-icon-divider-size-' + newValue;
                }
            }, true);
        }
    }
});